import script from "./CoreUiHtmlify.vue?vue&type=script&lang=ts"
export * from "./CoreUiHtmlify.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__